import { z } from "zod";

const ProductListNodeKey = z.string();

const ProductListLinkNodeSchema = z.object({
  key: ProductListNodeKey,
  keyList: z.array(ProductListNodeKey),
  name: z.string(),
  pimId: z.string(),
  parentId: z.union([ProductListNodeKey, z.null()]).default(null),
  nodes: z.array(z.any()).default([]),
});

const ProductListRootNodeSchema = ProductListLinkNodeSchema.omit({
  parentId: true,
});

const ProductListLeafNodeSchema = ProductListLinkNodeSchema.extend({
  countryOfOrigin: z.string(),
  serie: z.string(),
  serieId: z.number(),
  parentId: z.union([ProductListNodeKey, z.null()]), // Remove .default(null) here
}).omit({ nodes: true });

export type ProductListRootNode = z.infer<typeof ProductListRootNodeSchema>;
export type ProductListLinkNode = z.infer<typeof ProductListLinkNodeSchema>;
export type ProductListLeafNode = z.infer<typeof ProductListLeafNodeSchema>;
export type ProductListNode =
  | ProductListRootNode
  | ProductListLinkNode
  | ProductListLeafNode;

export const safeParse = {
  leaf: (node: unknown) => ProductListLeafNodeSchema.safeParse(node),
  root: (node: unknown) => ProductListRootNodeSchema.safeParse(node),
  link: (node: unknown) => ProductListLinkNodeSchema.safeParse(node),
};

// Todo, implement below to support the rafactoring mentioned in the productsOverviewStore.js

// type LinkedProductNodeType = {
//   key: z.infer<typeof ProductListNodeKey>;
//   children: LinkedProductNodeType[];
//   data: ProductListNode;
//   parent: LinkedProductNodeType | null;
// };

// const LinkedProductNodeSchema: z.ZodType<LinkedProductNodeType> = z.lazy(() =>
//   z.object({
//     key: ProductListNodeKey,
//     children: z.array(LinkedProductNodeSchema),
//     data: ProductListNodeSchema,
//     parent: LinkedProductNodeSchema.nullable(),
//   }),
// );

// export type LinkedProductNode = z.infer<typeof LinkedProductNodeSchema>;
